import { T } from "@classdojo/web";
import FullScreenCardPage from "./FullScreenCardPage";
import SlideNavigation from "./SlideNavigation";
import Tag from "./Tag";
import { RemoteSlideProps, Slide } from "./types";
import ShadowCard from "src/shared/components/ShadowCard";

export const ExpectationsSlide = (): Slide => {
  return {
    remote: ({ next }: RemoteSlideProps) => {
      return (
        <div sx={{ padding: "dt_s" }}>
          <ShadowCard sx={{ padding: "dt_l", textAlign: "center" }}>
            <div sx={{ fontSize: "24px" }}>{"It's time for a"}</div>
            <div sx={{ fontSize: "48px", fontWeight: 800 }}>
              <T str="dojo.toolkit:expectations_slide.conundrum" fallback="Conundrum!" />
            </div>
            <div
              sx={{
                fontSize: "16px",
                color: "dt_content_tertiary",
                marginTop: "dt_l",
              }}
            >
              <T str="dojo.toolkit:expectations_slide.remember" fallback="Remember..." />
            </div>
            <div sx={{ padding: "dt_s" }}>
              <Tag size="medium" color="dt_content_accent">
                <T str="dojo.toolkit:expectations_slide.be_open_minded" fallback="Be open-minded" />
              </Tag>
              <Tag size="medium" color="dt_content_accent">
                <T str="dojo.toolkit:expectations_slide.listen_to_each" fallback="Listen to each other" />
              </Tag>
              <Tag size="medium" color="dt_content_accent">
                <T str="dojo.toolkit:expectations_slide.there's_no_right" fallback='There’s no "right" answer!' />
              </Tag>
              <Tag size="medium" color="dt_content_accent">
                <T str="dojo.toolkit:expectations_slide.respect_others_opinions" fallback="Respect others' opinions" />
              </Tag>
            </div>
          </ShadowCard>
          <SlideNavigation onBack={() => next(-1)} onNext={() => next()} />
        </div>
      );
    },
    display: () => {
      return (
        <FullScreenCardPage sx={{ textAlign: "center", padding: "dt_xl" }}>
          <div sx={{ fontSize: "32px" }}>{"It's time for a"}</div>
          <div sx={{ fontSize: "64px", fontWeight: 800 }}>
            <T str="dojo.toolkit:expectations_slide.conundrum" fallback="Conundrum!" />
          </div>
          <div
            sx={{
              fontSize: "24px",
              color: "dt_content_tertiary",
              marginTop: "dt_l",
            }}
          >
            <T str="dojo.toolkit:expectations_slide.remember" fallback="Remember..." />
          </div>
          <div sx={{ padding: "dt_l" }}>
            <Tag size="large" color="dt_content_accent">
              <T str="dojo.toolkit:expectations_slide.be_open_minded" fallback="Be open-minded" />
            </Tag>
            <Tag size="large" color="dt_content_accent">
              <T str="dojo.toolkit:expectations_slide.listen_to_each" fallback="Listen to each other" />
            </Tag>
            <Tag size="large" color="dt_content_accent">
              <T str="dojo.toolkit:expectations_slide.there's_no_right" fallback='There’s no "right" answer!' />
            </Tag>
            <Tag size="large" color="dt_content_accent">
              <T str="dojo.toolkit:expectations_slide.respect_others_opinions" fallback="Respect others' opinions" />
            </Tag>
          </div>
        </FullScreenCardPage>
      );
    },
  };
};
